module.exports = __webpack_public_path__ + "assets/arrow.9e65f59d.svg";